<!-- 个人中心 -->
<template>
  <div class="page" v-cloak>
    <div class="header-block">
      <!-- <div class="qaindao" @click="onQiandao">
        签到
      </div> -->
      <!-- 用户头像 -->
      <div class="header-info-block" @click="goPage({ name: 'mine-service', query: {} })">
        <div class="user-img">
          <img v-if="userInfo.head_photo" :src="userInfo.head_photo" alt="" :οnerrοr="txFace" />
          <img v-else :src="missingFace" alt="" />
        </div>
        <div class="user-name">
          <p class="name" v-if="userInfo.phone_no">{{userInfo.user_nickname || '百分百生活馆'}}</p>
          <p class="name" v-else>请登录</p>
          <p class="tips" v-if="userInfo.phone_no">{{ userInfo.phone_no | hidePhone  }}</p>
          <p class="tips">查看和编辑个人信息</p>
        </div>

      </div>

      <!-- 
                // "total": "总金额",
        // "true_amt": "百分百钱包余额",
        // "points": "积分",
        // "wash_amt": "洗车余额",
        // "bfb": "百福币余额"
       -->
      <!-- 用户数据 -->
      <div class="header-data-block">
        <div class="header-data-item line" @click="goPage({ name: 'mine-bfb', query: {} })">
          <p class="num">{{bfb | numToCash }}</p>
          <p class="title">百福币</p>
        </div>
        <div class="header-data-item line" @click="goPage({ name: 'mine-balance-recharge', query: {} })">
          <p class="num">{{true_amt | numToCash}}</p>
          <p class="title">钱包</p>
        </div>
        <div class="header-data-item line" @click="goPage({ name: 'mine-wash-car', query: {} })">
          <p class="num">{{wash_amt | numToCash}}</p>
          <p class="title">必净洗车</p>
        </div>
        <!-- @click="goPage({name:'mine-balance',query:{}})" -->
        <div class="header-data-item" @click="goPage({ name: 'point-log-list', query: {} })">
          <p class="num">{{points | numToCash}}</p>
          <p class="title">积分</p>
        </div>
      </div>
    </div>
    <!-- 订单Icon -->
    <div class="order-block">
      <div :class="['order-rout-item', index == 0 ? 'line' : '']" v-for="(item, index) in orderList" :key="index" @click="goOrder(item)">
        <div class="order-icon">
          <img :src="item.icon" alt="" />
        </div>
        <p class="title">{{ item.title }}</p>
      </div>
    </div>

    <!-- 猜你喜欢 -->
    <!-- <you-like-scroll v-if="mobile"></you-like-scroll> -->

    <!-- 服务工具Icon -->
    <div class="service">
      <p class="service-title">服务工具</p>

      <div class="service-block">
        <div class="service-rout-item" v-for="(item, index) in serviceList" :key="index" @click="onService(item, index)">
          <div class="service-icon">
            <img :src="item.icon" alt="image" />
          </div>
          <p class="title">{{ item.title }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
// import youLikeScroll from "@/components/you-like-scroll/you-like-scroll.vue";
export default {
  name: "Mine",
  components: {
    // youLikeScroll
  },
  props: {},
  data() {
    return {
      missingFace: require("../../assets/mine/missing-face.png"),
      txFace: require("../../assets/mine/tx.png"),
      userInfo: {}, 
      orderList: [
        {
          icon: require("../../assets/mine/order_icon_1.png"),
          title: "全部订单",
          router: "order-list",
          tab: "",
        },
        {
          icon: require("../../assets/mine/order_icon_2.png"),
          title: "未付款",
          router: "order-list",
          tab: 1,
        },
        {
          icon: require("../../assets/mine/order_icon_3.png"),
          title: "未发货",
          router: "order-list",
          tab: 2,
        },
        {
          icon: require("../../assets/mine/order_icon_4.png"),
          title: "未收货",
          router: "order-list",
          tab: 3,
        },
        {
          icon: require("../../assets/mine/order_icon_5.png"),
          // title: "售后订单",
          title: "待评价",
          router: "order-list",
          tab: 4,
        },
      ],
      serviceList: [
        // {
        //   icon: require("../../assets/mine/service_icon_1.png"),
        //   title: "兑换订单",
        //   router: "exchange-order-list",
        // },
        {
          icon: require("../../assets/mine/service_icon_2.png"),
          title: "收货地址",
          router: "adderss-list",
        },
        {
          icon: require("../../assets/mine/service_icon_3.png"),
          title: "我的足迹",
          // router: "",
          router: "mine-foot-print",
        },
        {
          icon: require("../../assets/mine/service_icon_4.png"),
          title: "优惠卡劵",
          router: "mine-coupon",
        },
        {
          icon: require("../../assets/mine/service_icon_5.png"),
          title: "我的收藏",
          router: "mine-collection",
        },
        {
          icon: require("../../assets/mine/service_icon_6.png"),
          title: "我的评论",
          // router: "",
          router: "mine-comment",
        },
        {
          icon: require("../../assets/mine/service_icon_7.png"),
          title: "联系客服",
          router: "",
        },
        {
          icon: require("../../assets/mine/service_icon_8.png"),
          title: "关注我们",
          router: "mine-about",
        },
        {
          icon: require("../../assets/mine/service_icon_9.png"),
          title: "我的咨询",
          router: "mine-consult",
        },
        {
          icon: require("../../assets/mine/service_icon_10.png"),
          title: "分享码",
          router: "mine-shareCode",
        },
      ],

      true_amt: 0, //百分百钱包余额
      points: 0, //积分
      wash_amt: 0, //必净洗车余额
      bfb: 0, //百福币余额

      aa: {},
    };
  },
  watch: {
    aa: {
      handler(newValue, oldValue) {
        // console.log(newValue, oldValue);
      },
      deep: true, // 深度监听表单
    },
  },
  created() {},
  mounted() {
    //  是否登陆过
    if (!this.isLogin()) return false;
    // this.getInit(); //获取用户信息
    // this.getRefreshUid();
    //   this.getCollection();
    // }
    console.log(Lockr.get("userInfo"));
    console.log(this.$store.getters.userInfo);
    this.userInfo = Lockr.get("userInfo") || this.$store.getters.userInfo; //用户信息

    // this.getUser(); //获取用户信息
    this.getPoints();
    // this.getCollection();
    // this.getCoupon();
  },
  methods: {
    // 初始化数据
    getInit() {
      let _this = this;
      this.$toast.loading();
      _this.$post("/api/user_info").then((res) => {
        console.log(res, "user_info");
        _this.$toast.clear();
        if (res.data && res.data.code == 0) {
          let userData = res.data.data;

          Lockr.set("openId", userData.open_id);
          this.$store.commit("setOpenId", userData.open_id);

          // Lockr.set("userId", userData.user_id); // uid
          // this.$store.commit("set_user_id", userData.user_id);

          // Lockr.set("userInfo", userData); //用户信息
          // this.$store.commit("saveUser", userData);

          Lockr.set("referral_code", res.data.data.invite_code); // 邀请码
          this.$store.commit("set_referral_code", res.data.data.invite_code);

          Lockr.set("mobile", res.data.data.phone_no); // 手机号
          this.$store.commit("set_Mobile", res.data.data.phone_no);

          _this.userInfo =
            Lockr.get("userInfo") || _this.$store.getters.userInfo; //用户信息

          // refreshUid

          // "user_nickname": "BFBNyJZG",
          // "sex": 1,
          // "head_photo": "http:\/\/weizhui.xzbfb.com\/static\/avatar.jpg",
          // "phone_no": "18839135695",
          // "open_id": "oo05wvzjtnTRFecFjBLPY_ZMI5_M",
          // "invite_code": "XQJD8V",
          // "user_id": "5d022c3ad6fc4c0d6f9183dd7cbb6719",

          // user_info

          // user_nickname": "BFBNyJZG",
          // "phone_no": "18839135695",
          // "sex": 1,
          // "head_photo": "http:\/\/weizhui.xzbfb.com\/static\/avatar.jpg",
          // "open_id": "oo05wvzjtnTRFecFjBLPY_ZMI5_M",
          // "invite_code": "XQJD8V",
        } else if (res.data.code == -10004) {
          this.$toast.fail(res.data.message);
          this.$router.push({ name: "login" });
        }
      });
    },
    // getRefreshUid() {
    //   let _this = this;
    //   _this
    //     .$post(
    //       "/api/refreshUid",
    //       { openid: Lockr.get("openId") },
    //       { openid: Lockr.get("openId") }
    //     )
    //     .then((res) => {
    //       console.log(res.data.data, "refreshUid");
    //     });
    // },
    // getUser() {
    //   // console.log(this.$store.getters.userInfo)
    //   // console.log(this.$store.getters.mobile)
    //   let info = this.$store.getters.userInfo;
    //   (this.mobile = this.$store.getters.mobile || Lockr.get("mobile")),
    //     (this.userInfo = info);
    //   this.userInfo.head_photo =
    //     info.head_photo || require("../../assets/mine/tx.png");
    // },
    goOrder(item) {
      if (!this.isLogin()) return false;
      this.$router.push({
        name: item.router,
        query: {
          tab: item.tab,
        },
      });
    },
    onService(ite, ind) {
      if (!this.isLogin()) return false;
      if (ind == 5) {
        this.MakeCall(); //拨打电话
      } else if (ite.router) {
        this.$router.push({
          name: ite.router,
          query: {},
        });
      } else {
        this.$toast("敬请期待！");
      }
    },
    goPage(url) {
      if (!this.isLogin()) return false;
      // debugger
      this.$router.push(url);
    },
    goToast(url) {
      if (!this.isLogin()) return false;
      this.$toast("敬请期待！");
    },
    // 获取用户积分
    getPoints() {
      let _this = this;
      
      this.$toast.loading(); 
      _this.$post("/api/balance").then((res) => {
        console.log(res.data);
        if (res.data.code == 0) {
          _this.$toast.clear();
          _this.points = res.data.data.points || 0; //积分
          _this.true_amt = res.data.data.true_amt || 0; //百分百钱包余额
          _this.wash_amt = res.data.data.wash_amt || 0; //必净洗车余额
          _this.bfb = res.data.data.bfb || 0; //百福币余额
        }
      });
    },
    // // 获取收藏数
    // getCollection() {
    //   let _this = this;
    //   let data = {
    //     // status: 1, // 1 降价  2失效
    //     page: 1,
    //     limit: 10000,
    //   };
    //   _this.$post("/api/collect_list", data, data).then((res) => {
    //     if (res.data.code == 0) {
    //       _this.collection = res.data.data.length || 0;
    //     }
    //   });
    // },
    // 获取收藏数
    // getCoupon() {
    //   let _this = this;
    //   let data = {
    //     page: 1,
    //     limit: 10000,
    //   };
    //   _this.$post("/api/user_coupon_list", data, data).then((res) => {
    //     if (res.data.code == 0) {
    //       _this.couponNum = res.data.data.length || 0;
    //     }
    //   });
    // },

      // 签到
      onQiandao() {
      let _this = this;
      _this.$post("/api/user_sign_point").then((res) => {
        console.log(res.data);
        if (res.data.code == 0) { 
          _this.$toast(res.data.message);
          _this.getPoints();
        }else{
          _this.$toast(res.data.message);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  // height: 100%;
  width: 100%;
  padding-bottom: 50px;
  background-color: #f9f9f9;
}
.header-block {
  height: 260px;
  width: 100%;
  padding-top: 70px;
  background-color: #fff;
  background-image: url("../../assets/mine/h-bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: 0 0;
  position: relative;

  // 用户头像
  .header-info-block {
    height: 83px;
    width: 100%;
    // background-color: #eee;
    padding: 0 15px 0 30px;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    background-image: url("../../assets/mine/r-arrow.png");
    background-repeat: no-repeat;
    background-size: 9px 15px;
    background-position: 95% center;

    .user-img {
      width: 65px;
      height: 65px;
      border-radius: 50%;
      box-shadow: 0px 5px 5px rgba(69, 79, 99, 0.08);
      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }
    .user-name {
      text-align: left;
      margin-left: 10px;
      .name {
        font-size: 24px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        line-height: 41px;
        color: #454f63;
        letter-spacing: 1px;
      }
      .tips {
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        line-height: 21px;
        color: #999999;
      }
    }
  }
  .qaindao {
    position: absolute;
    right: 0;
    top: 35px;
    width: 70px;
    padding-left: 25px;
    // height: 50px;
    background-color: rgb(0, 0, 0, 0.2);
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 21px;
    color: #fff;
    border-top-left-radius: 15px;
    border-bottom-left-radius: 15px;

    background-image: url("../../assets/mine/qiandao.png");
    background-repeat: no-repeat;
    background-size: 15px 15px;
    background-position: 15% center;
  }
  // 用户数据
  .header-data-block {
    height: 55px;
    width: 100%;
    // background-color: rgba(69, 225, 225, 0.4);
    position: absolute;
    bottom: 20px;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    .header-data-item {
      width: 90px;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: relative;
      .num {
        font-size: 24px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #2a2e43;
        letter-spacing: 1px;
      }
      .title {
        margin-top: 10px;
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #666666;
        letter-spacing: 1px;
      }
    }
    .line::after {
      content: "";
      position: absolute;
      width: 1px;
      height: 30px;
      right: 0px;
      top: 30%;
      background: #707070;
      z-index: 1;
    }
  }
}
.order-block {
  width: 375px;
  height: 93px;
  margin-top: -10px;
  margin-bottom: 10px;
  background-color: transparent;
  background-image: url("../../assets/mine/order-bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: 0 0;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  .order-rout-item {
    width: 70px;
    height: 80px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    .order-icon {
      width: 24px;
      height: 24px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .title {
      margin-top: 10px;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #666666;
      letter-spacing: 1px;
    }
  }
  .line::after {
    content: "";
    position: absolute;
    width: 1px;
    height: 30px;
    right: 0px;
    top: 30%;
    background: #cccccc;
    z-index: 1;
  }
}
.service {
  background-color: #fff;
  margin: 10px 0;
  padding: 10px 0;
  .service-title {
    text-align: left;
    // border-left: 1px solid #ff5000;
    padding-left: 15px;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #2a2e43;
    letter-spacing: 1px;
    position: relative;
  }
  .service-title::before {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    height: 15px;
    width: 3px;
    background-color: #ff5000;
    -webkit-border-radius: 0 4px 4px 0;
    border-radius: 0 4px 4px 0;
  }
  .service-block {
    padding: 12px 12px 0 12px;
    display: flex;
    flex-wrap: wrap;

    .service-rout-item {
      width: 50px;
      height: 50px;
      margin: 10px 10px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .service-icon {
        width: 22px;
        height: 22px;
        img {
          // width: 100%;
          height: 100%;
        }
      }
      .title {
        margin-top: 10px;
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #666666;
      }
    }
  }
}
</style>
